import { connect } from 'react-redux'
import ProductList from '../components/ProductsList'
import {
  UndoRedo,
  requestProductsList,
  changePerPage,
  changeSort,
  changeTableView,
  changePagination,
  changeSearch,
  requestFilteredProductsList,
} from '../actions/productsActions'
import {
  getStartingIndex,
  getProductsArray,
  getProductsFullInfo,
  getProductsByCategory,
  getProductsByFilters,
  isSearchRequest,
} from '../selectors/defaultSelectors'

const initialProductRequest = (dispatch, params) => {
  if (
    typeof window.brand != 'undefined' ||
    typeof window.region != 'undefined' ||
    typeof window.country != 'undefined'
  ) {
    return dispatch(requestFilteredProductsList(params))
  } else {
    return dispatch(requestProductsList(params))
  }
}
const mapStateToProps = function (store) {
  const products = store.products.present
  const productsList = products.list
  const productsFullInfo = getProductsFullInfo(productsList, store)
  //const productsByCategory = getProductsByCategory(productsFullInfo, window.categoryID)
  //const productsByFilters = getProductsByFilters(productsByCategory, store.products.filters)
  const isEvolutionRewards = window?.categoryURL === 'evolution-rewards' ? true : false
  const additionalProps = {
    grid: {
      manual: true,
      pages: store.products.present.totalPages,
      pageIndex: store.products.present.activePage,
    },
  }

  return {
    isLoading: products.loading,
    additionalProps: additionalProps,
    tableView: products.tableView,
    perPage: products.perPage,
    sort: products.sort,
    activePage: products.activePage,
    startingIndex: getStartingIndex(products.perPage, products.activePage),
    products: getProductsArray(productsFullInfo),
    //products: getProductsArray(productsByFilters),
    hasActiveFilters: products.hasActiveFilters,
    hasSearch: !isSearchRequest(),
    blockLocalSearch: true,
    isEvolutionRewards,
  }
}
const mapDispatchToProps = function (dispatch, ownProps) {
  // const { history } = ownProps;
  // history.listen((location, action) => {
  //     dispatch(UndoRedo(location, action));
  // });

  return {
    requestProductsList: (params) => initialProductRequest(dispatch, params),
    //requestProductsList: (params) => dispatch(requestProductsList(params)),
    changePerPage: (params) => dispatch(changePerPage(params, 'list')),
    changeSort: (params) => dispatch(changeSort(params)),
    changeTableView: (params) => dispatch(changeTableView(params)),
    changePagination: (params) => dispatch(changePagination(params, 'list')),
    changeSearch: (params) => dispatch(changeSearch(params)),
  }
}
const ConnectedProductList = connect(mapStateToProps, mapDispatchToProps)(ProductList)

export default ConnectedProductList
